// contractData.ts
//
// PLACEHOLDER — not the final legal text.
// The real agreement was never stored in code: both sibche-5.0 and
// developer-panel-backend handled the contract as an uploaded PDF
// (publishers.contract_file_name), so there is no wording to port over.
// Replace the articles below with the text supplied by the legal team.
//
// The acceptance checkbox reports how many articles the user is agreeing to;
// it reads ARTICLE_COUNT below, so adding an article updates the label too.

const contractData = [
  'ماده 1- طرفین قرارداد:\nشرکت سیبچه با شماره ثبت 424784 و شماره ملی 1586674313، واقع در تهران، خیابان امام خمینی، ساختمان شرکت کد، طبقه 10، تلفن 02141478000، به نمایندگی آقای مهدی حیدری به عنوان طرف اول، و طرف دوم به نشانی مندرج در اطلاعات هویتی، منعقد می‌گردد.',
  'ماده 2- تعاریف:\n1-2. سایت سیبچه به آدرس اینترنتی sibche.com، به عنوان بستری برای ارائه و فروش نرم افزار توسط طرف اول تعریف می‌شود.\n2-2. «محتوا» شامل هر نوع داده، متن، نرم افزار، موسیقی، صدا، عکس، گرافیک، ویدیو، پیام یا سایر مواد می‌باشد که ممکن است توسط طرف اول در سایت سیبچه قرار داده شود.',
  'ماده 3- موضوع قرارداد:\nطرف اول متعهد می‌شود که محتوا را در سایت سیبچه به منظور فروش و ارائه به کاربران قرار دهد. طرف دوم حق بهره‌برداری از محتوای مذکور را برای مدت معینی دارد.',
  'ماده 4- مدت قرارداد:\nقرارداد از تاریخ امضا برای مدت 12 ماه معتبر است و به صورت خودکار تمدید نمی‌شود.',
];

/** Number of articles the acceptance checkbox refers to. */
export const ARTICLE_COUNT = contractData.length;

export default contractData;
